import { cn } from "../utils/styling";

type DividerProps = {
  className?: string;
  softest?: boolean;
};

export const DividerHorizontal = ({ className, softest }: DividerProps) => {
  return <div className={cn("h-1 w-full border-b-ds-subtle", softest && "border-b-ds-softest", className)} />;
};

export const DividerVertical = ({ className, softest }: DividerProps) => {
  return <div className={cn("h-full w-1 border-r-ds-subtle", softest && "border-r-ds-softest", className)} />;
};
